import React, { useContext } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";

let style = Object.assign({}, global);

const Callout = props => {
  const handleCalloutIconClick = () => {
    if (document.getElementById("editorBody").classList.contains("hide-secondAside")) props.toggle();
  };

  return (
    <li className={cx(style["toolset-group"])}>
      <div className={cx(style["toolset-item"], style["callout-wrap"])}>
        <span
          className={cx(style["toolset-action"], style["custom-tooltip"])}
          id="callout-toolbar"
          onClick={handleCalloutIconClick}>
          <Icon icon="ui-callouts" />

          <div className={cx(style["custom-tooltip-content"], style["top"])}>Update Callout</div>
        </span>
      </div>
    </li>
  );
};
Callout.propTypes = {
  toggle: PropTypes.func,
};

export default Callout;
